import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { DISAGREE_MESSAGES } from '../../utils/constants';
import { DisagreeButtonContainer } from './styles';

interface DisagreeButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const DisagreeButton: React.FC<DisagreeButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <DisagreeButtonContainer onClick={onClick} disabled={disabled}>
      <CloseCircleOutlined />
      {DISAGREE_MESSAGES.BUTTON_TEXT}
    </DisagreeButtonContainer>
  );
};
